export default __webpack_public_path__ + "static/media/photo--sm--135.ee7e15f9.jpg";